import React from 'react';
import {getWindow} from '../lib/utils';

const eventName = 'resize';

function getMediaQuery(maxWidth: string | null, matchString?: string) {
  if (matchString) {
    return matchString;
  }

  return maxWidth ? `(max-width: ${maxWidth})` : null;
}

export function useScreenResize(maxWidth: string | null, matchString?: string) {
  const [isInitialized, setIsInitialized] = React.useState(false);
  const [isMatch, setIsMatch] = React.useState(false);

  const handleResizeEvent = React.useCallback(() => {
    const adjustedMaxWidth = `${parseInt(maxWidth ?? '', 10) - 1}px`;
    const mediaQuery = getMediaQuery(adjustedMaxWidth, matchString);
    setIsInitialized(true);

    if (!mediaQuery) {
      setIsMatch(false);
      return;
    }

    const media = getWindow().matchMedia(mediaQuery);
    setIsMatch(Boolean(media?.matches));
  }, [maxWidth, matchString]);

  React.useEffect(() => {
    handleResizeEvent();
    getWindow().addEventListener(eventName, handleResizeEvent);

    return () => {
      getWindow().removeEventListener(eventName, handleResizeEvent);
    };
  }, [handleResizeEvent]);

  return {isMatch, isInitialized};
}
